import React from 'react'
import { render } from 'react-dom'

import App from './components/app/App'
import * as serviceWorker from './serviceWorker'
import './assets/scss/custom.scss'

const Root = () => (
    <App />
)

render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
